module.exports = __webpack_public_path__ + "img/news-title.24c8cbd.67a7395c.png";